import { gql } from '@apollo/client';

export const GET_ECP_PROFILE = gql`
  query GetEcpProfile {
    consumerLensesByAuthID {
      id
      createdManual
    }
    profile {
      id
      servicesAvailability {
        controlVisitAvailability
        annualEyeCheckAvailability
      }
      appointment {
        date
        status
      }
    }
  }
`;
